import {
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback } from "react";
import {
  useDownloadFileQuery,
  useUpdateFileMutation,
} from "src/api/services/bucketApi";
import { FileStorage } from "src/api/types";
import { columns } from "src/pages/FitnessAndNutrition/utils/columns";
import { statuses } from "src/pages/FitnessAndNutrition/utils/filters";

interface TableRowProps {
  row: FileStorage;
}

const PlansTableRow = ({ row }: TableRowProps) => {
  const [updateStatus] = useUpdateFileMutation();
  const { data: url } = useDownloadFileQuery({
    bucket: "resources",
    path: row.path,
  });

  const handleStatusUpdate = useCallback(
    async (value: string) => {
      await updateStatus({ id: row.id, status: value });
    },
    [row.id, updateStatus]
  );

  if (url == null) {
    return "";
  }

  return (
    <TableRow hover role="checkbox" aria-label="plan row" tabIndex={-1}>
      {columns.map((column) => {
        const value = column.format(row);

        const isStyled = ["title", "status"].includes(column.id);

        return (
          <TableCell key={row.id} align={column.align}>
            {column.id === "title" ? (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                {row.title}
              </a>
            ) : column.id === "status" ? (
              <TextField
                select
                value={row.status}
                size="small"
                sx={{ width: "fit-content" }}
                onChange={(e) => handleStatusUpdate(e.target.value)}
              >
                {statuses.map((status) => (
                  <MenuItem key={status} value={status}>
                    {" "}
                    {status}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <Typography
                sx={{
                  textDecoration: isStyled ? "underline" : "none",
                  cursor: isStyled ? "pointer" : "",
                }}
              >
                {value}
              </Typography>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default PlansTableRow;
